import { render, staticRenderFns } from "./I18nMessageEdit.vue?vue&type=template&id=d0364028&scoped=true&"
import script from "./I18nMessageEdit.vue?vue&type=script&lang=js&"
export * from "./I18nMessageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0364028",
  null
  
)

export default component.exports